export default class BackofficeEntityItemsBase {
  constructor(type) {
    this.type = type; // 'product' or 'option'
    this.bindEvents();
  }

  bindEvents() {
    $(".js-switch").each((index, element) => {
      const id = $(element).data("id");
      const entityId = $(element).data("entity-id");
      const isEntityItem = $(element).data(`is-entity-${this.type}`);

      $(element).unbind("change").change((e) => {
        this.toggle_permissions(id, $(e.target).is(':checked') ? '1' : '0', entityId, isEntityItem);
      });
    });
  }

  onDataChanged(data) {}

  onDestroy() {
    $(".js-switch").unbind("change");
  }

  toggle_permissions(id, value, entityId, isEntityItem) {
    let data = {};
    let field_value = {};
    field_value["for_sale"] = value
    data[`entity_${this.type}`] = field_value
    data[`is_entity_${this.type}`] = isEntityItem

    let ajax_data = {
      url: `/entities/${entityId}/entity_${this.type}s/${id}/ajax_update`,
      data: data,
      method: "put",
      success: (data) => {
        application.successNotification(I18n.t("backoffice.products.update.success"))
      },
      error: (err) => {
        application.errorNotification(I18n.t("backoffice.products.update.error"))
      }
    }

    $.ajax(ajax_data)
  }
}